import { Canvas, Text, View } from '@react-pdf/renderer'

import { styles } from '@/components/StatsExport/components/BarChartSection/BarChartSection.config'
import type { BarChartSectionProps } from '@/components/StatsExport/components/BarChartSection/BarChartSection.types'
import { NoData } from '@/components/StatsExport/components/NoData/NoData'

export function BarChartSection({ data, title }: BarChartSectionProps) {
  if (!data) return <NoData title={title} />

  const counts = Object.values(data).map(count => Number(count))
  const total = counts.reduce((sum, count) => sum + count, 0)

  const createBar = (
    painter: any,
    availableWidth: number,
    availableHeight: number,
    percentageValue: number,
  ) => {
    painter
      .roundedRect(
        0,
        0,
        (availableWidth / 100) * percentageValue,
        availableHeight,
        8,
      )
      .fill('#1EA896')

    return null
  }

  return (
    <View style={styles.box} wrap={false}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.charts}>
        {Object.keys(data).map(value => {
          const percentageValue = total ? (data[value] / total) * 100 : 0

          return (
            <View key={value}>
              <Canvas
                paint={(painter, availableWidth, availableHeight) =>
                  createBar(
                    painter,
                    availableWidth,
                    availableHeight,
                    percentageValue,
                  )
                }
                style={styles.canvas}
              />
              <View style={styles.chartInfo}>
                <Text style={styles.text}>{value}</Text>
                <Text style={styles.text}>{Math.floor(percentageValue)}%</Text>
              </View>
            </View>
          )
        })}
      </View>
    </View>
  )
}
